/* =====================================================================
   Bluewud × Empire v13 — Custom Quick Shop / Choose Options modal.
   The native v13 quick-shop is dead, so this builds the popup from Shopify's
   /products/{handle}.js endpoint. Two modes (like v6):
     • Quick Shop  → detailed card: image, title, price, a little description,
       variant options, qty, add-to-cart, "view full details".
     • Choose Options → MINIMAL card: just title, price, variant options, qty,
       add-to-cart (no image / vendor / description) for a quick variant pick.
   The card's `.bw-btn--quick` opens detailed; `.bw-btn--choose` opens minimal.
   ===================================================================== */
(function () {
  'use strict';

  var overlay, modal, current = { product: null, variant: null, url: '', options: {}, minimal: false };

  function money(cents) {
    return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'bw-qs-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="bw-qs-modal" role="dialog" aria-modal="true" aria-label="Quick shop">' +
        '<button class="bw-qs-close" type="button" aria-label="Close">&times;</button>' +
        '<div class="bw-qs-grid">' +
          '<div class="bw-qs-media"><img class="bw-qs-img" alt=""></div>' +
          '<div class="bw-qs-info">' +
            '<div class="bw-qs-vendor"></div>' +
            '<h2 class="bw-qs-title"></h2>' +
            '<div class="bw-qs-price"></div>' +
            '<p class="bw-qs-desc"></p>' +
            '<div class="bw-qs-options"></div>' +
            '<div class="bw-qs-qtyrow"><span class="bw-qs-qtylabel">Qty</span>' +
              '<div class="bw-qs-qty"><button type="button" data-qs-minus aria-label="Decrease">&minus;</button>' +
              '<input class="bw-qs-qtyinput" type="number" value="1" min="1" inputmode="numeric" aria-label="Quantity">' +
              '<button type="button" data-qs-plus aria-label="Increase">+</button></div></div>' +
            '<button type="button" class="bw-qs-add">Buy now</button>' +
            '<a class="bw-qs-viewfull" href="#">View full details</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    modal = overlay.querySelector('.bw-qs-modal');
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.bw-qs-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) close(); });
    overlay.querySelector('[data-qs-minus]').addEventListener('click', function () { stepQty(-1); });
    overlay.querySelector('[data-qs-plus]').addEventListener('click', function () { stepQty(1); });
    overlay.querySelector('.bw-qs-add').addEventListener('click', onAddClick);
  }

  function stepQty(d) {
    var inp = overlay.querySelector('.bw-qs-qtyinput');
    inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + d);
  }

  function open(handle, url, minimal) {
    if (!overlay) build();
    current.url = url || ('/products/' + handle);
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    current.minimal = !!minimal;
    modal.classList.toggle('bw-qs-modal--minimal', !!minimal);
    modal.classList.add('bw-qs-loading');
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('not ok'); return r.json(); })
      .then(function (p) { current.product = p; render(p); })
      .catch(function () { if (current.url) location.href = current.url; });
  }

  function stripHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Shopify gives single-variant products a synthetic option named "Title"
  // with the single value "Default Title" — there's no real choice to make,
  // so it must never render (that's the stray "[object Object]" / "Default
  // Title" control). Also normalise options that arrive as objects.
  function realOptions(p) {
    if (p.has_only_default_variant) return [];
    var out = [];
    (p.options || []).forEach(function (opt, i) {
      var name = (typeof opt === 'string') ? opt : ((opt && opt.name) || '');
      var values = [];
      p.variants.forEach(function (v) {
        var val = v['option' + (i + 1)];
        if (val != null && values.indexOf(val) < 0) values.push(val);
      });
      if (!name) return;
      if (name === 'Title' && values.length === 1 && values[0] === 'Default Title') return;
      out.push({ name: name, index: i, values: values });
    });
    return out;
  }

  function render(p) {
    modal.classList.remove('bw-qs-loading');
    overlay.querySelector('.bw-qs-vendor').textContent = p.vendor || '';
    overlay.querySelector('.bw-qs-title').textContent = p.title;
    overlay.querySelector('.bw-qs-viewfull').href = current.url;
    overlay.querySelector('.bw-qs-qtyinput').value = 1;

    // A little of the product page (detailed mode only; CSS hides it in minimal).
    var desc = stripHtml(p.description);
    if (desc.length > 200) desc = desc.slice(0, 197) + '…';
    overlay.querySelector('.bw-qs-desc').textContent = desc;

    var optWrap = overlay.querySelector('.bw-qs-options');
    optWrap.innerHTML = '';
    current.options = {};
    realOptions(p).forEach(function (opt) {
      var group = document.createElement('div');
      group.className = 'bw-qs-optgroup';
      var label = document.createElement('div');
      label.className = 'bw-qs-optname';
      label.textContent = opt.name;
      group.appendChild(label);
      var row = document.createElement('div');
      row.className = 'bw-qs-optvals';
      opt.values.forEach(function (val, vi) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bw-qs-optval';
        b.textContent = val;
        if (vi === 0) { b.classList.add('is-selected'); current.options[opt.index] = val; }
        b.addEventListener('click', function () {
          row.querySelectorAll('.bw-qs-optval').forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          current.options[opt.index] = val;
          selectVariant();
        });
        row.appendChild(b);
      });
      group.appendChild(row);
      optWrap.appendChild(group);
    });
    selectVariant();
  }

  function selectVariant() {
    var p = current.product;
    var keys = Object.keys(current.options);
    var variant = (p.has_only_default_variant || keys.length === 0)
      ? p.variants[0]
      : p.variants.find(function (v) {
          return keys.every(function (i) {
            return v['option' + (parseInt(i, 10) + 1)] === current.options[i];
          });
        });
    current.variant = variant;

    var priceEl = overlay.querySelector('.bw-qs-price');
    var addBtn = overlay.querySelector('.bw-qs-add');
    var img = overlay.querySelector('.bw-qs-img');
    if (variant) {
      var html = '<span class="bw-qs-cur">' + money(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ' <span class="bw-qs-cmp">' + money(variant.compare_at_price) + '</span>';
      }
      priceEl.innerHTML = html;
      var src = (variant.featured_image && variant.featured_image.src) || p.featured_image || (p.images && p.images[0]);
      if (src) img.src = src;
      addBtn.disabled = !variant.available;
      // Choose Options (minimal) = Add to cart; Quick Shop (detailed) = Buy now.
      addBtn.textContent = variant.available ? (current.minimal ? 'Add to cart' : 'Buy now') : 'Sold out';
    } else {
      priceEl.textContent = '';
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
    }
  }

  // CTA dispatch: Choose Options (minimal) adds to cart and stays; Quick Shop
  // (detailed) adds and goes straight to checkout.
  function onAddClick() {
    if (current.minimal) addToCart();
    else buyNow();
  }

  // Add to cart (Choose Options): add the chosen variant, confirm, then close.
  function addToCart() {
    if (!current.variant || !current.variant.available) return;
    var qty = Math.max(1, parseInt(overlay.querySelector('.bw-qs-qtyinput').value, 10) || 1);
    var addBtn = overlay.querySelector('.bw-qs-add');
    var orig = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: current.variant.id, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        addBtn.textContent = 'Added ✓';
        setTimeout(function () { addBtn.textContent = orig; addBtn.disabled = false; close(); }, 950);
      })
      .catch(function () { addBtn.textContent = orig; addBtn.disabled = false; });
    // Header cart count refreshes via the /cart/add.js fetch wrapper in bluewud-cards.js.
  }

  // Buy now: add the chosen variant, then go straight to checkout.
  function buyNow() {
    if (!current.variant || !current.variant.available) return;
    var qty = Math.max(1, parseInt(overlay.querySelector('.bw-qs-qtyinput').value, 10) || 1);
    var addBtn = overlay.querySelector('.bw-qs-add');
    var orig = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Processing…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: current.variant.id, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        // Straight to checkout — this is a "Buy now", not an add-and-stay.
        window.location.href = '/checkout';
      })
      .catch(function () { addBtn.textContent = orig; addBtn.disabled = false; });
  }

  function close() {
    if (overlay) { overlay.hidden = true; document.body.style.overflow = ''; }
  }

  // Card buttons carry data-handle. `.bw-btn--choose` opens the minimal popup.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bw-btn[data-handle]');
    if (!btn) return;
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    e.preventDefault();
    var minimal = btn.classList.contains('bw-btn--choose');
    open(handle, btn.getAttribute('href'), minimal);
  });
})();
